import * as Styled from "./style";
import { ProductInfo } from "~/components/blocks/product/common/blocks/product-tab-contents/product-info";
import { SPOT_LIVE_SELECT_TABS } from "~/components/blocks/product/const";
import type { G_GetVideoQuery } from "~/lib/graphql";

export type VideoSpotLiveSeasonTabContentsProps = {
  /** videoクエリを叩いて取得したデータ */
  videoData: G_GetVideoQuery["video"];
  /** 現在選択中のタブの値 */
  selectedTabValue: string;
  /**
   * エピソードの合計数
   * - TODO : エピソードタブは初期リリースの範囲外。実装着手できるようになったらコメントアウト外す
   */
  // totalEpisodeLength: number;
  /**
   * API通信完了後に本編映像の合計数を更新するイベントハンドラ
   * - TODO : エピソードタブは初期リリースの範囲外。実装着手できるようになったらコメントアウト外す
   */
  // onTotalMainEpisodeChange: (totalCount: number) => void;
};

/**
 * スポット配信 | 作品末端のタブに紐づくコンテンツを表示するコンポーネント
 * - SEO的な都合上、Tab切り替えでコンテンツのマウント/アンマウントをするのは良くない
 * - なので、全てレンダリングした状態で表示/非表示を指定する
 * @param props {@link VideoSpotLiveSeasonTabContentsProps}
 */
export const VideoSpotLiveSeasonTabContents = (props: VideoSpotLiveSeasonTabContentsProps) => {
  const { videoData, selectedTabValue } = props;

  return (
    <div>
      {/** MEMO : 初期リリース時点ではエピソードタブは表示させなくてOKなのでコメントアウト */}
      {/* <Styled.DivContentsBox isShow={selectedTabValue === SPOT_LIVE_SELECT_TABS.EPISODE}>
        <Episode
          titleName={videoData.titleName}
          seasonName={videoData.seasonName}
          seasonType={videoData.seasonType}
          totalEpisodeLength={totalEpisodeLength}
          onTotalMainEpisodeChange={onTotalMainEpisodeChange}
        />
      </Styled.DivContentsBox> */}

      <Styled.DivContentsBox isShow={selectedTabValue === SPOT_LIVE_SELECT_TABS.PRODUCT_INFO}>
        <ProductInfo videoData={videoData} />
      </Styled.DivContentsBox>
    </div>
  );
};
